import { Flex, Text } from '@electricjs/arc';
import { useTranslation } from 'react-i18next';

type HaveIBeenPwnedAttributionProps = {
  fontSize: string;
};

export const HaveIBeenPwnedAttribution = ({
  fontSize = '1rem',
}: HaveIBeenPwnedAttributionProps) => {
  const { t } = useTranslation('pages');

  return (
    <Flex>
      <Text fontSize={fontSize} variant="body-2">
        {t('passwordBreaches.attribution')}{' '}
        <a target="_blank" href="https://haveibeenpwned.com" rel="noreferrer">
          haveibeenpwned.com
        </a>
      </Text>
    </Flex>
  );
};
